export const compositePublishUrlParametersPrefix = "composite.";

export const compositePublishUrlParameters = [
  "signalingURL",
  "applicationName",
  "streamName",
  "audioBitrate",
  "audioCodec",
  "videoBitrate",
]